/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import {
  CSSProperties,
  HTMLAttributeAnchorTarget,
  MouseEventHandler,
} from 'react';
import { ReactJSXElement } from '@emotion/react/types/jsx-namespace';

interface LinkProps {
  href: string;
  children: string | ReactJSXElement;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  target?: HTMLAttributeAnchorTarget;
  style?: CSSProperties;
}

const Link = ({ href, onClick, children, target, style }: LinkProps) => {
  return (
    <a
      href={href}
      onClick={onClick}
      target={target || '_blank'}
      rel={(!target || target === '_blank') ? 'noopener noreferrer' : undefined}
      css={css`
        color: #28b379;
      `}
      style={style}
    >
      {children}
    </a>
  );
};

export default Link;
